module.exports = __webpack_public_path__ + "education-48.76b20ae3088ee7321cd8.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/education/webfont/education-48.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/education/webfont/education-48.woff
// module chunks = styles